import * as React from "react";
const CompactandElegantDesign = (props) => (
  <svg
    width={37}
    height={30}
    viewBox="0 0 37 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 25.5V4.5C1 3.5375 1.343 2.71383 2.029 2.029C2.715 1.34417 3.53867 1.00117 4.5 1H32.5C33.4625 1 34.2867 1.343 34.9727 2.029C35.6587 2.715 36.0012 3.53867 36 4.5V25.5C36 26.4625 35.6576 27.2867 34.9727 27.9727C34.2879 28.6587 33.4637 29.0012 32.5 29H4.5C3.5375 29 2.71383 28.6576 2.029 27.9727C1.34417 27.2879 1.00117 26.4637 1 25.5ZM32.5 13.25V4.5H4.5V13.25H32.5ZM15 25.5H32.5V16.75H15V25.5ZM4.5 25.5H11.5V16.75H4.5V25.5Z"
      stroke="url(#paint0_linear_2681_9030)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2681_9030"
        x1={18.5}
        y1={1}
        x2={18.5}
        y2={29}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD702" />
        <stop offset={0.296875} stopColor="#FFD702" stopOpacity={0.59375} />
        <stop offset={1} stopColor="#FFD702" stopOpacity={0.12} />
      </linearGradient>
    </defs>
  </svg>
);
export default CompactandElegantDesign;
